import Idle from './Idle';
import InView from './InView';
import Timeout from './Timeout';

const RenderOn = {
	Idle,
	InView,
	Timeout,
};

export default RenderOn;
